import { CustomMatSelectDeselectAllComponent } from './component/custom-mat-select-deselect-all/custom-mat-select-deselect-all.component';
import { MaterialModule } from './angular-material/material.module';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MascaraDirective } from './mascara.directive';
import { DualListCustomComponent } from './dual-list-custom/dual-list-custom.component';
import { SomaPipe } from './soma.pipe';
import { MoedaLocalPipe } from '../moeda-local.pipe';
import { CountPipe } from './count.pipe';
import { SortHeaderComponent } from './sort-header/sort-header.component';
import { ConfirmacaoComponent } from './confirmacao/confirmacao.component';
import { SelectBilhetadoraOperadoraComponent } from './component/select-bilhetadora-operadora/select-bilhetadora-operadora.component';
import { MaskOnlyNumbersDirective } from './directives/mask-only-numbers/mask-only-numbers.directive';
import { ModalTemplateComponent } from './component/modal-template/modal-template.component';
import { ClickStopPropagationDirective } from './directives/click-stop-propagation/click-stop-propagation.directive';
import { BpToastComponent } from './component/bp-toast/bp-toast.component';
import { LgpdMaskPipe } from './lgpd-mask.pipe';
import { ModalSelecionarOperadoraComponent } from '../cadastro/programacao-viagem-escala/programacao-viagem-escala/modal-selecionar-operadora/modal-selecionar-operadora.component';

@NgModule({
  declarations: [
    MascaraDirective,
    DualListCustomComponent,
    SomaPipe,
    MoedaLocalPipe,
    CountPipe,
    SortHeaderComponent,
    ConfirmacaoComponent,
    SelectBilhetadoraOperadoraComponent,
    CustomMatSelectDeselectAllComponent,
    MaskOnlyNumbersDirective,
    ModalTemplateComponent,
    ClickStopPropagationDirective,
    BpToastComponent,
    LgpdMaskPipe,
    ModalSelecionarOperadoraComponent
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [
    MascaraDirective,
    DualListCustomComponent,
    SomaPipe,
    MoedaLocalPipe,
    CountPipe,
    SortHeaderComponent,
    ConfirmacaoComponent,
    SelectBilhetadoraOperadoraComponent,
    ModalSelecionarOperadoraComponent,
    CustomMatSelectDeselectAllComponent,
    MaskOnlyNumbersDirective,
    ClickStopPropagationDirective,
    MaterialModule,
    LgpdMaskPipe,
  ],
  entryComponents: [
    ConfirmacaoComponent,
    SelectBilhetadoraOperadoraComponent,
    ModalSelecionarOperadoraComponent,
    CustomMatSelectDeselectAllComponent,
    BpToastComponent,
  ],
})
export class ShareModule {}
